module.exports = __webpack_public_path__ + "img/1488099851.e7f4ed62.jpg";